// import frontpage from './modules/frontpage';
// import page from './modules/page';
// import links from './modules/links';
//
// import horizontalAutoScroll from './modules/horizontalAutoScroll';
// import scrolling from './modules/scrolling';
//
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';
// import swipers from './modules/swipers';
//
// import Alpine from 'alpinejs';
// import focus from '@alpinejs/focus';
// import intersect from '@alpinejs/intersect';
// // import {ScrollTrigger} from "gsap/ScrollTrigger";
//
// frontpage();
// page();
// links();
//
// swipers();
//
// if (window.innerWidth > 1024) {
//     scrolling();
//     horizontalAutoScroll();
//
//     window.addEventListener('resize', () => {
//         ScrollTrigger.refresh();
//     });
// }
//
//
// Alpine.plugin(intersect);
// Alpine.plugin(focus);

import.meta.glob([ '../img/**', ]);
import.meta.glob([ '../static/**', ]);

// import './scripts/gtm-trackings.js';

import Form from './class/form'; //
const form = new Form(); //

import './test';
import './scripts/single-room.js';


import './scripts/booking.js';
// import './scripts/checkout.js';
import './scripts/checkout_v2.js';

// import './scripts/contact-forms-tracking.js';
import './scripts/customDatesPopup.js';

import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';
import gsap from 'gsap';
// import { ScrollSmoother } from 'gsap-trial/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './scripts/social-proof-section.js'

// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);

// import Form from './class/form'; //
import swipers from './modules/swipers';
import links from './modules/links';
import scrolling from './modules/scrolling';
import horizontalAutoScroll from './modules/horizontalAutoScroll';
// import frontpage from './modules/frontpage';
import page from './modules/page';
import initMap from './modules/nearByMap';
// import mobile from './modules/mobile';

// //////// Forms
// const form = new Form(); //

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';

// frontpage();
swipers();
page();
links();

const mapDiv = document.querySelector('#map-near-by');
if (mapDiv){
    initMap()
}




Alpine.plugin(intersect);
Alpine.plugin(focus);
const headerButtons = document.querySelector('.js-header-buttons');
const getHeaderButtons = (count) => {
    if (!headerButtons) {
        return false;
    }

    if (count > 50) {
        headerButtons.classList.add('is-active');
    } else {
        headerButtons.classList.remove('is-active');
    }
};

document.addEventListener('alpine:init', () => {

    Alpine.data('app', () => ({
        menuOpen: false,
        openlightbox: false,
        buttonSwitcher: false,

        toggleMenu() {
            const burgerBg = document.querySelector('.js-burger-bg');
            const burgerContainer = document.querySelector('.js-burger-container');
            const burgerdetails = document.querySelector('.js-burger-details');

            if (burgerContainer.classList.contains('loading')) {
                return false;
            }
            if (this.menuOpen) {
                //NOTE: IDK what to do with this

                // ScrollSmoother.create({
                //     smoothTouch: false,
                //
                //     smooth: 0.85,
                //     normalizeScroll: true,
                //     ignoreMobileResize: true,
                //     effects: true,
                //     preventDefault: true,
                //     onUpdate: (self) => {
                //         getHeaderButtons(self.scrollTop());
                //     },
                //     ease: 'expo.out',
                // });

                this.buttonSwitcher = !this.buttonSwitcher;

                burgerContainer.classList.add('loading');

                gsap.to(burgerdetails, {
                    opacity: 0,
                    duration: 0.3,
                });

                const menuItems =
                    burgerContainer.children[1].querySelectorAll('.menu-item');



                for (let index = menuItems.length - 1; index >= 0; index--) {
                    gsap.to(menuItems[index], {
                        opacity: 0,
                        delay: 0.2 - index / 9,
                        duration: 0.3,
                    });
                }

                gsap.to(burgerContainer.children[0], {
                    opacity: 0,
                    delay: 0.4,
                });

                gsap.to(burgerBg, {
                    top: '100%',
                    delay: 0.8,
                    duration: 0.8,
                    ease: 'power2.inOut',
                });

                setTimeout(() => {
                    burgerContainer.parentElement.parentElement.classList.add(
                        'menu-is-closed'
                    );
                    burgerContainer.parentElement.parentElement.classList.remove(
                        'menu-is-open'
                    );
                    burgerContainer.classList.remove('loading');
                    document.querySelector('html').classList.remove('no-scroll');
                    this.menuOpen = !this.menuOpen;
                }, 1600);
            } else {
                // let smooth = ScrollSmoother.get();
                //
                //
                // if (smooth) {
                //     smooth.kill();
                // }

                this.buttonSwitcher = !this.buttonSwitcher;
                this.menuOpen = !this.menuOpen;
                burgerContainer.classList.add('loading');
                burgerContainer.parentElement.parentElement.classList.remove(
                    'menu-is-closed'
                );
                burgerContainer.parentElement.parentElement.classList.add(
                    'menu-is-open'
                );
                document.querySelector('html').classList.add('no-scroll');
                gsap.to(burgerBg, {
                    top: '0',
                    ease: 'power2.inOut',
                    duration: 1,
                });

                gsap.to(burgerContainer.children[0], {
                    opacity: 1,
                    delay: 0.9,
                });

                const menuItems =
                    burgerContainer.children[1].querySelectorAll('.menu-item');

                for (let index = 0; index < menuItems.length; index++) {
                    gsap.to(menuItems[index], {
                        opacity: 1,
                        delay: index === 0 ? 0.7 : 0.7 + index / 9,
                        duration: 0.3,
                    });
                }

                gsap.to(burgerdetails, {
                    opacity: 1,
                    delay: 1.1,
                    onComplete: () => {
                        burgerContainer.classList.remove('loading');
                    },
                });
            }
        },

        lightbox(id) {
            const slider = document.querySelector('.js-lightbox-slider');
            const title = document.querySelector('.js-lightbox-title');

            if (this.openlightbox) {
                slider.innerHTML = '';
                title.innerHTML = '';
                document.querySelector('html').classList.remove('no-scroll');
            } else {
                document.querySelector('html').classList.add('no-scroll');
                const data = new FormData();
                data.append('action', 'lightbox');
                data.append('id', id);
                fetch(ajaxObject.ajax_url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: data,
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error != '1') {
                            title.innerHTML = data.title;
                            slider.innerHTML = data.data;
                            const singleSlider = slider.querySelector(
                                '.js-single-gallery-slider'
                            );
                            const singleNav =
                                slider.parentElement.querySelector('.js-gallery-nav');
                            const count =
                                slider.parentElement.querySelector('.js-gallery-count');

                            new Swiper(singleSlider, {
                                navigation: {
                                    prevEl: singleNav?.children[0],
                                    nextEl: singleNav?.children[1],
                                },
                                loop: true,
                                speed: 1200,
                                slidesPerView: 'auto',
                                observer: true,
                                observeParents: true,
                                //centeredSlides: true,
                                breakpoints: {
                                    300: {
                                        spaceBetween: 2,
                                    },
                                    768: {
                                        spaceBetween: 4,
                                    },
                                    1025: {
                                        spaceBetween: 4,
                                    },
                                },
                                on: {
                                    afterInit: () => {
                                        count.innerHTML = singleSlider
                                            .querySelector('.swiper-slide-active')
                                            .getAttribute('aria-label');
                                    },
                                    slideChangeTransitionStart: () => {
                                        count.innerHTML = singleSlider
                                            .querySelector('.swiper-slide-active')
                                            .getAttribute('aria-label');
                                    },
                                },
                            });
                        }
                    });
            }
            this.openlightbox = !this.openlightbox;
        },

        scrollTo(selector) {
            //NOTE: IDK what to do with this

            // let smooth = ScrollSmoother.get();
            // ScrollTrigger.refresh();
            // setTimeout(() => {
            //     if (smooth) {
            //         ScrollTrigger.refresh();
            //         smooth.scrollTo(selector, true, 'top 20px');
            //     } else {
            //         document
            //             .querySelector(selector)
            //             .scrollIntoView({ behavior: 'smooth' });
            //     }
            // }, 400);
        },

        init() {

            // const mainNavigation = document.querySelector('.js-main-navigation');
            // if(mainNavigation){
            //     const mainNavElements = mainNavigation.querySelectorAll('.menu-item');
            //     for(const element of mainNavElements){
            //         element.addEventListener('click', () => {
            //             this.toggleMenu();
            //         });
            //     }
            // }

        },
    }));
});

Alpine.start();
horizontalAutoScroll();
if (window.innerWidth <= 1024) {
    // mobile();
}

if (window.innerWidth > 1024) {
    scrolling();
    // horizontalAutoScroll();

    window.addEventListener('resize', () => {
        ScrollTrigger.refresh();
    });
}

// CookieYes
document.addEventListener(
    'DOMContentLoaded',
    function () {
        setTimeout(() => {
            const manageCookiesBtn = document.querySelector('.cky-btn-customize');

            function refreshScrolling(smoother) {
                scrolling();
                setTimeout(() => {
                    smoother.refresh();
                }, 1000);
            }

            //NOTE: IDK what to do with this

            // if (manageCookiesBtn) {
            //     let smoother = ScrollSmoother.get();
            //
            //     manageCookiesBtn.addEventListener('click', function () {
            //         smoother.kill();
            //
            //         const saveCookiesPreferencesBtn = document.querySelector(
            //             '.cky-btn-preferences'
            //         );
            //         const acceptAllCookiesBtns =
            //             document.querySelectorAll('.cky-btn-accept');
            //
            //         const closeManageCookiesModalBtn =
            //             document.querySelector('.cky-btn-close');
            //         if (saveCookiesPreferencesBtn) {
            //             saveCookiesPreferencesBtn.addEventListener('click', function () {
            //                 refreshScrolling(smoother);
            //             });
            //         }
            //         if (acceptAllCookiesBtns) {
            //             acceptAllCookiesBtns.forEach((btn) => {
            //                 btn.addEventListener('click', function () {
            //                     refreshScrolling(smoother);
            //                 });
            //             });
            //         }
            //         if (closeManageCookiesModalBtn) {
            //             closeManageCookiesModalBtn.addEventListener('click', function () {
            //                 refreshScrolling(smoother);
            //             });
            //         }
            //     });
            // }
        }, 1000);
    },
    false
);

/* If browser back button was used, flush cache */
(function () {
    window.onpageshow = function (event) {
        if (event.persisted) {
            window.location.reload();
        }
    };
})();




import './scripts/videos';
import './scripts/header';
import './scripts/roomsFilter';



// INQUIRE POPUP AND TRIGGERS
const inquirePopup = document.getElementById('inquirePopup');
const inquirePopupCloseButton = document.getElementById('inquirePopupClose');
const inquirePopupTriggers = document.querySelectorAll('.js-inquire-trigger');


inquirePopupTriggers.forEach(trigger =>{
    trigger.addEventListener('click', ()=>{
        inquirePopup.classList.remove('hidden');
        document.documentElement.classList.add('no-scroll');

    });

});

inquirePopupCloseButton.addEventListener('click', ()=>{
    inquirePopup.classList.add('hidden')
    document.documentElement.classList.remove('no-scroll');
})


//SINGLE ROOMS PAGE:
const singleRoomTemplate = document.querySelector('.single-rooms');
const relatedRoomsSlider = document.getElementById('relatedRoomsSlider');
let isSliderLoading = false
let season = '';

if (singleRoomTemplate && relatedRoomsSlider){

    const urlParams = new URLSearchParams(window.location.search);
    season = urlParams.get('season');


    if (season !== '' && season !== null ){
        loadRelatedRooms();
    }
}

function loadRelatedRooms(){
    const data = new FormData();
    data.append('action', 'load_slider_rooms')
    data.append('season', season)
    data.append('nonce', ajaxObject.nonce)
    data.append('post_id', ajaxObject.post_id)
    isSliderLoading = true;


    fetch(ajaxObject.ajax_url,{
        method: "POST",
        body: data
    })
        .then(response=>{
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
        .then(response => {
            console.log(response);
            relatedRoomsSlider.innerHTML = response.data.html;
            swipers();


        })
        .catch(error => {
            console.log(error)
        })
        .finally(()=>{
            isSliderLoading = false
            }
        )

}

function initRoomSlider(sliderWrapper){
    // return new Swiper(sliderWrapper, {
    //     navigation: {
    //         prevEl: relatedRoomsSliderPagination?.children[0],
    //         nextEl: relatedRoomsSliderPagination?.children[1],
    //     },
    //     loop: false,
    //     breakpoints: {
    //         300: {
    //             spaceBetween: 20,
    //             slidesPerView: 1,
    //         },
    //         768: {
    //             spaceBetween: 20,
    //             slidesPerView: 2,
    //         },
    //         1025: {
    //             spaceBetween: 20,
    //             slidesPerView: 3,
    //         },
    //     },
    //     pagination: {
    //         el: relatedRoomsSliderNav,
    //         type: 'bullets',
    //         clickable: true,
    //     },
    // })
}


// ROOMS SELECT POPUP:
// const roomsSelectPopup = document.getElementById('roomsSelectPopup');
// const closeSelectPopupButton = document.getElementById('closeSelectPopup');
//
// const roomsSelectPopupTriggers = document.querySelectorAll('.js-select-popup-trigger');
//
// const longTermCheckbox = document.getElementById('long-term-rent');
// const popupSeasonsList = document.getElementById('popupSeasonsList');
//
//
// const roomsPage = document.querySelector('body.page-template-template-rooms');

// if (roomsPage){
//     const hasSeasonParam = new URLSearchParams(window.location.search).has('season');
//     const hash = window.location.hash;
//
//     if (!hasSeasonParam && hash !== '#short'){
//         showRoomsSelectPopup()
//     }
//
// }

// //Show seasons only if long term is selected
// longTermCheckbox.addEventListener('change', ()=>{
//     if (longTermCheckbox.checked){
//         popupSeasonsList.classList.remove('hidden')
//     }else{
//         popupSeasonsList.classList.add('hidden')
//     }
// })

// roomsSelectPopupTriggers.forEach(trigger => {
//     trigger.addEventListener('click', (e)=>{
//         e.preventDefault()
//
//         console.log('trigger')
//
//         if (trigger.classList.contains('js-long-term')){
//             longTermCheckbox.checked = true;
//             longTermCheckbox.dispatchEvent(new Event('change'))
//         }
//         showRoomsSelectPopup()
//     })
// })
//
// closeSelectPopupButton.addEventListener('click', ()=> {
//     roomsSelectPopup.classList.add('hidden');
// })

// function showRoomsSelectPopup(){
//     roomsSelectPopup.classList.remove('hidden');
// }
//
// window.addEventListener('invalidSeason', () => {
//     console.log('event recieved')
//     showRoomsSelectPopup();
// });


// const roomsFilterWrapper = document.getElementById('roomsFilterWrapper');
// const filterCheckboxes = document.querySelectorAll('.filter-checkbox');
//
// const roomsLoader = document.getElementById('rooms-loader');
// const roomsContainer = document.getElementById('rooms-container');
//
// let isLoading = false;
//
// if (roomsFilterWrapper){
//
//     roomsFilterWrapper.addEventListener('click', (e)=>{
//         if (isLoading) {
//             e.preventDefault();
//             return;
//         }
//     }, true)
//
//
//     roomsFilterWrapper.addEventListener('change', (e) => {
//
//         if (isLoading) {
//             e.preventDefault();
//             return;
//         }
//
//         // Check if the changed element is actually a radio button
//         e.preventDefault();
//         if (e.target.type === 'checkbox') {
//
//             const seasonId = e.target.value;
//
//             if (!e.target.checked) {
//                 e.target.checked = true;
//                 console.log('same checkbox')
//                 return;
//             }
//
//             filterCheckboxes.forEach(checkbox=>{
//
//                 if (checkbox.value !== seasonId){
//                     checkbox.checked = false;
//                 }
//             })
//
//
//             roomsContainer.style.display = 'none';
//             roomsLoader.style.display = 'flex';
//
//
//             const data = new FormData();
//             data.append('action', 'load_rooms');
//             data.append('season', seasonId);
//             data.append('nonce', ajaxObject.nonce);
//             isLoading = true;
//
//             // Your AJAX code here...
//             fetch(ajaxObject.ajax_url, {
//                 method: "POST",
//                 // credentials: 'same-origin',
//                 body: data
//             })
//                 .then(response => {
//                     if (!response.ok) {
//                         throw new Error(`[${response.status}] ${response.statusText}`);
//                         // console.log('error');
//                         // console.log(response);
//                     }
//                     return response.json();
//                 })
//                 .then(response => {
//                     console.log(response);
//                     roomsContainer.innerHTML = response.data.html;
//                     roomsContainer.style.display = 'grid';
//                     roomsLoader.style.display = 'none';
//                     isLoading = false;
//                     swipers();
//
//                 })
//                 .catch(error => {
//                     console.error(error);
//                 });
//
//             // Update URL
//             const url = new URL(window.location.href);
//             url.searchParams.set('season', seasonId);
//             history.replaceState({}, '', url.toString());
//
//         }
//     });
// }

import intlTelInput from 'intl-tel-input';

const inputs = document.querySelectorAll(".js-phone-input");

inputs.forEach((input) => {
    intlTelInput(input, {
        hiddenInput: (telInputName) => ({
            phone: "js-full-phone-number",
        }),
        separateDialCode: true,
        initialCountry: 'auto',
        geoIpLookup: callback => {
            fetch("https://ipapi.co/json")
                .then(res => res.json())
                .then(data => callback(data.country_code))
                .catch(() => callback("pl"));
        },
        autoPlaceholder: 'aggressive',
        loadUtils: () => import("intl-tel-input/utils"),
    });
})





// Find your menu links
// const menuLinks = document.querySelectorAll('.menu-item');
//
// // Add proper event listeners to ensure they work
// menuLinks.forEach(link => {
//     console.log(link)
//     link.addEventListener('click', (event) => {
//         // Prevent any default scroll handling that might be occurring
//         event.stopPropagation();
//         console.log('click?')
//
//         // Check if this is actually navigating somewhere (not just a # link)
//         if (link.getAttribute('href') && link.getAttribute('href') !== '#') {
//             // Use the href attribute to navigate
//             window.location.href = link.getAttribute('href');
//         }
//     });
// });
//
// // Add this temporarily to debug
// document.addEventListener('click', function(e) {
//     e.preventDefault()
//     console.log('Click target:', e.target);
//     console.log('Is link?', e.target.tagName === 'A' || e.target.closest('a'));
//     // Don't prevent default - just log
// }, true);